<template>
  <div class="myworksheet-container">
    <div class="jc-page-top">
      <!-- <div class="jc-page-header"> -->
        <div class="jc-page-header">
          <h1>
            <i class="jc-icon-my-circle-bold"></i>{{$t('ticket.myWork')}}
          </h1>
          <div class="jc-box-action">
            <a v-bind:href="Config.MYWORKSHEET_SERVER_URL"
               target="_blank">{{$t('ticket.helpDoc',[$t('ticket.myWork')])}}</a>
          </div>
        </div>
      <!-- </div> -->
      <div class="jc-page-content">
        <div class="my_worksheet_box">
          <el-row :gutter="20"
                  class="worksheet-row-type"
                  style="margin: 0px 0px">
            <el-col :span="6"
                    v-for="(item,index) in workSheetStatus.label"
                    :key="index">
              <div class="worksheet-grid-content worksheet-state"
                   @click="filterStatusList(item.value,index)">
                <p class="worksheet-state-count"
                   :class="{'worksheet-state-count-on': item.value === selectStatus}">{{workSheetStatus['num'+
                  index]}}</p>
                <p class="worksheet-state-text">{{item.label}}</p>
              </div>
            </el-col>
          </el-row>
          <el-row class="worksheet-row"
                  type="flex"
                  justify="space-between">
            <!-- 表格上方筛选等 -->
            <div class="myworksheet-toolbar">
              <div class="myworksheet-toolbar-item">
                <el-date-picker type="daterange"
                                v-model="datarange"
                                align="left"
                                :picker-options="pickerOptions2"
                                @change="handleIconClick"
                                :start-placeholder="$t('placeholder.start_placeholder')"
                                :end-placeholder="$t('placeholder.end_placeholder')"
                                style="width: 100%;"
                                :editable='false'></el-date-picker>
              </div>
              <div class="myworksheet-toolbar-item">
                <el-select id="my-select"
                           @change="changeSearch"
                           v-model="currentSearch"
                           :placeholder="$t('placeholder.choose')"
                           style="width:130px">
                  <el-option
                             v-for="item in searchSelect"
                             :key="item.searchValue"
                             :label="item.searchLabel"
                             :value="item.searchValue"></el-option>
                </el-select>
                <el-input :placeholder="searchPlaceholder[currentSearch]"
                          v-model="searchContent"
						  style="width:270px"
                          @keyup.enter.native="handleIconClick" clearable @clear="handleIconClick">
                  <el-button slot="append"
                             @click="handleIconClick"
                             icon="el-icon-search"></el-button>
                </el-input>
                <el-button icon="jc-icon-refresh-line"
                           class="el-button-icon el-button-icon-bk set-icon"
                           @click="updateList()"></el-button>
                <el-button icon="el-icon-setting"
                           class="el-button-icon el-button-icon-bk set-icon"
                           @click="setCustom()"
                           :title="$t('merge.customList')"></el-button>
                <el-button icon="jc-icon-download"
                           class="el-button-icon el-button-icon-bk"
                           @click="exportList"
                           :title="$t('ticket.exportWorksheetList')"></el-button>
              </div>
            </div>
          </el-row>
          <el-row>
            <!-- 表格主体 -->
            <div class="el-container-table">
              <el-table :data="worksheetList"
                        tooltip-effect="dark"
                        style="width: 100%"
                        v-loading="refreshloading"
                        @sort-change="changeTime"
                        @filter-change="changeFilter"
                        ref="table"
                        :empty-text="tableEmptyTip">
                <el-table-column prop="ticketNo"
                                 key="ticketNo"
                                 :label="$t('ticket.ticketNo')"
                                 v-if="customerInfo !== null && customerInfo['ticketNo'].selected">
                  <template slot-scope="scope">
                    <!-- 草稿 -->
                    <a href="javascript:void(0)"
                       class="a-link-text"
                       v-if="scope.row.status == 'draft'"
                       @click="jump_to_ticket(scope.row)">{{scope.row.ticketNo}}</a>
                    <!-- 详情 -->
                    <a href="javascript:void(0)"
                       class="a-link-text"
                       v-else
                       @click="jump_to_detail(scope.row.ticketNo)">{{scope.row.ticketNo}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="ticketName"
                                 key="ticketName"
                                 :label="$t('ticket.workName')"
                                 v-if="customerInfo !== null && customerInfo['ticketName'].selected"></el-table-column>
                <el-table-column prop="ticketTypeName"
                                 key="ticketTypeName"
                                 :label="$t('ticket.workType')"
                                 v-if="customerInfo !== null && customerInfo['ticketType'].selected"
                                 column-key="ticketType"
                                 :filters="ticketTypes_map"
                                 :filter-multiple="false"
                                 filter-placement="bottom-end"> </el-table-column>
                <el-table-column prop="ticketStatus"
                                 key="ticketStatus"
                                 :label="$t('text.status')"
                                 v-if="customerInfo !== null && customerInfo['ticketStatus'].selected"
                                 column-key="ticketStatus"
                                 :filters="ticketStatus_map"
                                 :filter-multiple="false"
                                 filter-placement="bottom-end"> </el-table-column>
                <el-table-column prop="applyId"
                                 key="applyId"
                                 :label="$t('text.applyId')"
                                 v-if="customerInfo !== null && customerInfo['applyId'].selected"
                                  column-key="applyId"
                                 :filters="userFilter"
                                 :filter-multiple="false"
                                 filter-placement="bottom-end"
                                 show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>{{scope.row.applyId | maybeEmpty}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="description"
                                 key="description"
                                 :label="$t('ticket.remark')"
                                 v-if="customerInfo !== null && customerInfo['remark'].selected"
                                 show-overflow-tooltip>
                                 <template slot-scope="scope">
                    <span>{{scope.row.description | maybeEmpty}}</span>
                  </template>
                                 </el-table-column>
                <el-table-column prop="createdTime"
                                 key="createdTime"
                                 :label="$t('ticket.setUpTime')"
                                 v-if="customerInfo !== null && customerInfo['createdTime'].selected"
                                 show-overflow-tooltip
                                 sortable> </el-table-column>
                <el-table-column prop="closedTime"
                                 key="closedTime"
                                 :label="$t('ticket.closeTime')"
                                 v-if="customerInfo !== null && customerInfo['closedTime'].selected"
                                 show-overflow-tooltip
                                 sortable>
                  <template slot-scope="scope">
                    {{scope.row.closedTime.trim() === ''?" --":scope.row.closedTime}}
                  </template>
                </el-table-column>
                <el-table-column prop="operate"
                                 key="operate"
                                 :label="$t('text.operate')"
                                 v-if="customerInfo !== null && customerInfo['operation'].selected">
                  <template slot-scope="scope">
                    <!-- 草稿编辑 -->
                    <el-button v-if="scope.row.status == 'draft'"
                               @click.native.prevent="jump_to_ticket(scope.row)"
                               type="text"
                               size="small">{{$t('roomEntry.edit')}}</el-button>
                    <!-- 草稿删除 -->
                    <el-button v-if="scope.row.status == 'draft'"
                               @click.native.prevent="draftDelete(scope.row)"
                               type="text"
                               size="small">{{$t('roomEntry.delete')}}</el-button>
                    <el-button v-else
                               @click.native.prevent="jump_to_detail(scope.row.ticketNo)"
                               type="text"
                               size="small">{{$t('text.check')}}</el-button>
                    <el-button @click="handleOption(scope.row,'verify1')"
                               type="text"
                               size="small"
                               v-if="scope.row.userOperation.indexOf(3) > -1 && scope.row.currentTaskNodeId === 'Plan_Verify'">{{$t('text.verify')}}</el-button>
                    <el-button @click="handleOption(scope.row,'verify2')"
                               type="text"
                               size="small"
                               v-if="scope.row.userOperation.indexOf(3) > -1  && scope.row.currentTaskNodeId === 'Consign_Verify'">{{$t('text.verify')}}</el-button>
                    <el-button @click="handleOption(scope.row,'revoke')"
                               type="text"
                               size="small"
                               v-if="scope.row.userOperation.indexOf(2) > -1">{{$t('text.revokeVerb')}}</el-button>
                    <el-button @click="handleOption(scope.row,'close')"
                               type="text"
                               size="small"
                               v-if="scope.row.userOperation.indexOf(4) > -1">{{$t('text.closeTicket')}}</el-button>
                    <el-button @click="handleOption(scope.row,'verifyConfirm')"
                                      type="text"
                                      size="small"
                                      v-if="scope.row.userOperation.indexOf(3) > -1  && scope.row.currentTaskNodeId === 'Consumer_Confirm'">
                              {{$t('text.verify')}}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-row>
        </div>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar"
         v-if="worksheetList.length">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pageSizes"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalItems">
      </el-pagination>
    </div>
    <!-- 自定义 -->
    <custom :visible.sync="customVisible"
            v-if="customVisible"
            :optionArr="optionArr"
            :type="type"></custom>
    <!-- 弹框 -->
    <dailog-show :currentDailog.sync="currentDailog"
                 :currentTicketNo.sync="currentTicketNo"
                 @updateList="updateList()"
                 :currentTaskNodeId.sync="currentTaskNodeId"></dailog-show>
    <!-- 删除草稿 -->
    <delete-draft :visible.sync="deletetVisiable"
                  :title="$t('text.draftTicket')"
                  :deleteNo="deleteTicketNo"
                  v-if="deletetVisiable"
                  @handleDelete="handleDelete"></delete-draft>
  </div>
</template>

<script>
import custom from '../common/custom/Custom.vue';
import dailogShow from './WorksheetAction';
import submit from './SubmitWorkSheet';
import DeleteDraft from './common/delete';

const type = 'ticket';

export default {
  components: { custom, dailogShow, DeleteDraft },
  data () {
    return {
      deletetVisiable: false,
      deleteTicketNo: '',
      refreshloading: false, // refreshLoading
      worksheetList: [], // 我的工单列表
      currentPage: 1, // 当前页
      totalItems: 0, // 带宽总数
      pageSize: 20, // 默认每页20条
      pageSizes: [20, 50, 100], // 可选每页展示多少条
      datarange: [], // 时间范围
      searchSelect: [
        {
          searchValue: 'ticketNo',
          searchLabel: this.$t('ticket.ticketNo')
        },
        {
          searchValue: 'ticketTemplateName',
          searchLabel: this.$t('ticket.workName')
        },
        {
          searchValue: 'description',
          searchLabel: this.$t('ticket.remark')
        }
      ],
      searchPlaceholder: {
        ticketNo: this.$t('placeholder.worksheetNo'),
        ticketTemplateName: this.$t('placeholder.worksheetName'),
        description: this.$t('placeholder.worksheetRemark')
      },
      ticketType: '',
      ticketStatus: '',
      currentSearch: 'ticketNo', // 当前筛选条件
      searchContent: '', // 搜索内容
      ticketStatus_map: [], // 工单状态过滤
      ticketTypes_map: [], // 工单状态过滤
      selectStatus: 'all', // 选中的过滤工单状态
      selectType: 'all', // 选中工单状态码
      worksheetCount: null, // 请求得到4中工单状态数据
      currentStatus: '', // 当前筛选状态
      createTimeFliter: null, // 当前时间筛选
      createTimeAttr: null, // 当前时间筛选条件
      currentTaskNodeId: '', // 当前节点
      workSheetStatus: {
        label: [
          { label: this.$t('ticket.waitMeProcessed'), value: 'pendingProcess' },
          { label: this.$t('ticket.pending'), value: 'pendingReview' },
          { label: this.$t('ticket.processing'), value: 'processing' },
          { label: this.$t('ticket.complete'), value: 'all' }
        ],
        num0: 0,
        num1: 0,
        num2: 0,
        num3: 0
      },
      currentDailog: '',
      currentTicketNo: null,
      customVisible: false,
      type,
      optionArr: [
        { label: this.$t('ticket.ticketNo'), value: 'ticketNo' },
        { label: this.$t('ticket.workName'), value: 'ticketName' },
        { label: this.$t('ticket.workType'), value: 'ticketType' },
        { label: this.$t('text.status'), value: 'ticketStatus' },
        { label: this.$t('text.applyId'), value: 'applyId' },
        { label: this.$t('ticket.remark'), value: 'remark' },
        { label: this.$t('ticket.setUpTime'), value: 'createdTime' },
        { label: this.$t('ticket.closeTime'), value: 'closedTime' },
        { label: this.$t('text.operate'), value: 'operation' }
      ],
      pickerOptions2: {
        shortcuts: [
          {
            text: this.$t('merge.lastWeek'),
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: this.$t('merge.lastMonth'),
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: this.$t('merge.lastThreeMonth'),
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ],
        disabledDate (time) {
          return time.getTime() < new Date('1970-01-01');
        }
      },
      userFilter: [],
      submitAccount: '',
      tableEmptyTip: this.$t('merge.noData')
    };
  },
  created () {
    this.getWorkList();
    if (this.$store.state.customInfo[this.type] === null) {
      this.getCustomInfo();
    }
    this.getBaseInfoAndSubUsers();
  },

  async beforeMount () {
    const res = await this.$api.getWorksheetMap({ idcLine: this.GLOBAL.IDCLINE });
    this.$store.commit('GET_WORKSHEETLIST', res.data);
    this.ticketStatus_map = this.worksheetMap[this.selectType];
    this.ticketTypes_map = this.worksheetMap.ticketTypes;
    // this.ticketTypes_map = res.data.ticketTypes;
    // console.log(this.ticketTypes_map);
  },

  computed: {
    worksheetMap () {
      console.log(this.$store.state.wkMap);
      return this.$store.state.wkMap.worksheetList;
    },
    customerInfo () {
      return this.$store.state.customInfo[this.type];
    }
  },

  methods: {
    draftDelete ({ ticketNo }) {
      this.deleteTicketNo = ticketNo;
      this.deletetVisiable = true;
    },
    getBaseInfoAndSubUsers () {
      this.$api.getBaseInfoAndSubUsers().then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK' && res.data) {
          if (res.data.users) {
            res.data.users.forEach((item) => {
              const obj = {
                value: item.name
              };
              if (item.type === 'subUser') {
                obj.text = `${item.account}/${item.name}`;
              } else {
                obj.text = item.name;
              }
              this.userFilter.push(obj);
            });
          }
        }
      }).catch((err) => {
        this.$message.error(err.errmsg);
      });
    },
    handleDelete (child) {
      this.$api.deleteDraft({ 'ticketNo': child.deleteNo }).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK' && res.data) {
          child.handleColse();
          this.updateList();
        }
      }).catch((err) => {
        this.$message.error(err.errmsg);
      });
    },

    changeSearch () {
      this.searchContent = '';
    },

    getWorkList (params) {
      const self = this;
      const dataParams = {
        pageNumber: self.currentPage,
        pageSize: self.pageSize,
        idcLine: self.GLOBAL.IDCLINE,
        type: self.selectType
      };
      const tempParams = params || dataParams;
      this.refreshloading = true;
      this.$api.getWorkList(tempParams).then((temp) => {
        if (temp.errno === 10000 && temp.errmsg === 'OK') {
          if (temp.data && temp.data.tickets
            && temp.data.tickets.length > 0
            && temp.data.tickets[0] != null) {
            this.worksheetList = temp.data.tickets;
            this.refreshloading = false;
          } else {
            this.refreshloading = false;
            this.worksheetList = [];
          }
          this.totalItems = temp.data.totalCount;
          this.worksheetCount = temp.data.count;
          this.setWorksheetStatus();
        }
      }).catch((err) => {
        this.$message.error(err.errmsg);
      }).finally(() => {
        this.refreshloading = false;
      });
    },

    getCustomInfo () {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((response) => {
        if (response.errno === 10000 && response.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: response.data.customInfo, type: this.type });
        }
      });
    },

    setWorksheetStatus () {
      this.workSheetStatus.num0 = this.worksheetCount.dealing;
      this.workSheetStatus.num1 = this.worksheetCount.review;
      this.workSheetStatus.num2 = this.worksheetCount.handling;
      this.workSheetStatus.num3 = this.worksheetCount.all;
    },

    updateList (realParams) {
      let params = null;
      const tempParams = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        idcLine: this.GLOBAL.IDCLINE,
        type: this.selectType
      };
      params = realParams || tempParams;
      this.tableEmptyTip = this.$t('text.noSearch');
      // 设置搜索状态下无数据表格提示内容
      if (this.currentStatus != '' || (this.currentSearch != '' && this.searchContent != '') || (this.datarange !== null && this.datarange[0] && this.datarange[1])) {
        this.tableEmptyTip = this.$t('text.hasSearch');
      }

      console.log(this.ticketType);
      if (this.ticketType != '') {
        this.tableEmptyTip = this.$t('text.hasSearch');
        params = Object.assign(params, { 'ticketTypeId': this.ticketType });
      }
      if (this.submitAccount != '') {
        this.tableEmptyTip = this.$t('text.hasSearch');
        params = Object.assign(params, { 'submitAccount': this.submitAccount });
      }
      // 状态搜索
      if (this.ticketStatus != '') {
        params = Object.assign(params, { 'status': this.ticketStatus });
      }
      // 单号备注搜索
      if (this.currentSearch != '' && this.searchContent != '') {
        if (this.currentSearch === 'ticketNo') {
          params = Object.assign(params, { 'ticketNo': this.searchContent });
        } else if (this.currentSearch === 'description') {
          params = Object.assign(params, { 'description': this.searchContent });
        } else if (this.currentSearch === 'ticketTemplateName') {
          params = Object.assign(params, { 'ticketTemplateName': this.searchContent });
        } else return;
      }
      // 时间搜索
      if (this.datarange !== null && this.datarange[0] && this.datarange[1]) {
        const time1 = this.formatStandardTime2Start(this.datarange[0]);
        const time2 = this.formatStandardTime2End(this.datarange[1]);
        params = Object.assign(params, { startTime: time1, endTime: time2 });
      }
      // 升序降序时间搜索
      if (this.createTimeAttr && this.createTimeFliter) {
        if (this.createTimeAttr == 'ascending') {
          // 升序
          params = Object.assign(params, { 'sortName': this.createTimeFliter, sortDirection: 'asc' });
        } else if (this.createTimeAttr == 'descending') {
          // 降序
          params = Object.assign(params, { 'sortName': this.createTimeFliter, sortDirection: 'desc' });
        }
      }
      this.getWorkList(params);
    },

    handleIconClick () {
      this.currentPage = 1;
      this.updateList();
    },

    jump_to_ticket (data) {
      const route = submit.methods.getRoute(data);
      this.$router.push({
        path: route,
        query: {
          idcLine: this.GLOBAL.idcLine,
          ticketNo: data.ticketNo
        }
      });
    },

    jump_to_detail (ticketNo) {
      const routeData = this.$router.resolve({
        path: `/myworksheet/detail/${ticketNo}`,
      });
      window.open(routeData.href, '_blank');
    },

    handleOption (row, type) {
      this.currentTicketNo = row.ticketNo;
      this.currentTaskNodeId = row.currentTaskNodeId;
      if (type == 'close') {
        this.currentDailog = 'close';
      } else if (type == 'revoke') {
        this.currentDailog = 'revoke';
      } else if (type == 'verify1') {
        this.currentDailog = 'verify1';
      } else if (type == 'verify2') {
        this.currentDailog = 'verify2';
      } else if (type == 'verifyConfirm') {
        this.currentDailog = 'verifyConfirm';
      } else return false;
    },

    exportList () {
      let url = `/ccs-api/api/ticket/exportTickets?idcLine=${this.GLOBAL.IDCLINE}&type=${this.selectType}&all=1`;
      // 状态搜索
      if (this.ticketStatus != '' && this.ticketStatus !== undefined) {
        url += `&status=${this.ticketStatus}`;
      }
      if (this.ticketType != '' && this.ticketType !== undefined) {
        url += `&ticketTypeId=${this.ticketType}`;
      }
      if (this.submitAccount != '' && this.submitAccount !== undefined) {
        url += `&submitAccount=${this.submitAccount}`;
      }

      // 单号备注搜索
      if (this.currentSearch != '' && this.searchContent != '') {
        url += `&${this.currentSearch}=${this.searchContent}`;
      }
      // 时间搜索
      if (this.datarange !== null && this.datarange[0] && this.datarange[1]) {
        const time1 = this.formatStandardTime2Start(this.datarange[0]);
        const time2 = this.formatStandardTime2End(this.datarange[1]);
        url += `&startTime=${time1}&endTime=${time2}`;
      }
      // 升序降序时间搜索
      if (this.createTimeAttr && this.createTimeFliter) {
        if (this.createTimeAttr == 'ascending') {
          url += `&sortName=${this.createTimeFliter}&sortDirection=asc`;
        } else if (this.createTimeAttr == 'descending') {
          url += `&sortName=${this.createTimeFliter}&sortDirection=desc`;
        }
      }
      console.log(url);
      window.open(url, '_self');
    },

    changeFilter (filter) {
      this.currentPage = 1;
      this.currentStatus = '';
      for (const key in filter) {
        if (key == 'ticketType') {
          this.ticketType = filter.ticketType[0];
        }
        if (key == 'ticketStatus') {
          this.ticketStatus = filter.ticketStatus[0];
          this.currentStatus = filter.ticketStatus[0];
        }
        if (key == 'applyId') {
          this.submitAccount = filter.applyId[0];
        }
      }
      this.updateList();
    },

    setCustom () {
      this.customVisible = true;
    },

    handleSizeChange (val) {
      this.pageSize = val;
      this.updateList();
    },

    handleCurrentChange (val) {
      this.currentPage = val;
      this.updateList();
    },

    filterStatusList (value, index) {
      console.log(value);
      console.log(index);
      // 恢复工单号搜索
      this.currentSearch = 'ticketNo';
      // 根据状态过滤列表
      this.currentPage = 1;
      this.refreshloading = true;
      this.selectStatus = value;
      this.ticketStatus_map = this.worksheetMap[value];
      this.selectType = value;
      // 清空table筛选信息
      this.$refs.table.clearSort();
      this.$refs.table.clearFilter();
      // 清空升序降序筛选、状态筛选
      this.currentStatus = '';
      this.createTimeAttr = '';
      this.createTimeFliter = '';
      // 清空内容筛选
      this.searchContent = '';
      // 清空时间筛选
      this.datarange = [];
      this.tableEmptyTip = this.$t('text.noSearch');
      this.getWorkList();
    },

    changeTime (column) {
      this.currentPage = 1;
      this.createTimeAttr = column.order;
      if (column.prop == 'closedTime') {
        this.createTimeFliter = 'closedTime';
      } else if (column.prop == 'createdTime') {
        this.createTimeFliter = 'createdTime';
      }
      this.updateList();
    }
  }
};
</script>
<style lang="scss">
@import "./scss/MyWorksheet";
</style>



// WEBPACK FOOTER //
// src/components/workSheet/MyWorksheet.vue